import React, { useEffect, useContext } from "react";

import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "bodycodi/cmap/app/redux/store";
import { fetchPartnerList } from "bodycodi/cmap/app/redux/slices/partnerSlice";
import { callApi, endWithConsonant } from "bodycodi/cmap/app/js/common";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/cmap2020/scheduleDtlHeader";
import Info from "bodycodi/cmap/app/components/cmap5010/info";
import main from "bodycodi/cmap/app/img/icon_flag.png";
import main_gray from "bodycodi/cmap/app/img/icon_flag_gray.png";
import icon_center_remove from "bodycodi/cmap/app/svg/icon_center_remove.svg";
import icon_center_default from "bodycodi/cmap/app/svg/icon_center_default.svg";

const CenterMngtPopWrap = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "CENTER_MNGT_POP", open: { centerMngtPop: false } });
  };

  const handleClickInfo = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CENTER_MNGT_INFO_POP",
      open: { centerMngtInfoPop: true },
    });
  };

  return (
    <CustomDialog open={state.centerMngtPop} onClose={handleClose}>
      <PopupHeader
        title="연동센터 설정 관리"
        rightIconType="info"
        onClickBack={handleClose}
        onClickRightIcon={handleClickInfo}
      />
      {state.centerMngtPop && <CenterMngtPop />}
    </CustomDialog>
  );
};

const CenterMngtPop = () => {
  const dispatchRedux = useDispatch<AppDispatch>();
  const { partnerList: partnerBranchList } = useSelector((state: RootState) => state.partner);

  useEffect(() => {
    dispatchRedux(fetchPartnerList());
  }, []);

  const handleFetchPartnerList = () => {
    dispatchRedux(fetchPartnerList());
  };

  return (
    <div className="popup-body center-mngt-pop">
      <div className="title">주 연동센터 설정</div>
      <div>
        {partnerBranchList.map((d: any) => (
          <Partner key={d.seqPartnerCoach} d={d} handleFetchPartnerList={handleFetchPartnerList} />
        ))}
      </div>
      <Info />
    </div>
  );
};

interface Partner {
  d: any;
  handleFetchPartnerList: () => void;
}

const Partner = ({ d, handleFetchPartnerList }: Partner) => {
  const { dispatch } = useContext(DispatchContext);

  const handleUpdateMainPartner = () => {
    callApi(
      "/cmap5020/execMainPartnerUpd",
      {
        seqPartner: d.seqPartner,
        seqPartnerBranch: d.seqPartnerBranch,
        seqPartnerCoach: d.seqPartnerCoach,
      },
      "POST"
    ).then(() => {
      handleFetchPartnerList();
      dispatch({ type: "UPDATE_HOME_PARTNER_LIST_REFRESH" });
    });
  };

  const handleClickUpdateMainPartner = () => {
    const centerName = d.partnerBranchName
      ? d.partnerName + " " + d.partnerBranchName
      : d.partnerName;
    dispatch({
      type: "ALERT_SETTING",
      data: {
        header: "주 이용센터 설정",
        cancleYn: true,
        redYn: false,
        body: centerName + `${endWithConsonant(centerName)} \n 주 이용센터로 설정하시겠어요?`,
        cancelAlert: () => {
          return;
        },
        closeAlert: handleUpdateMainPartner,
        alert: true,
      },
    });
  };

  const handleDeletePartner = () => {
    callApi(
      "/cmap5020/execParnterMapDel",
      {
        seqPartner: d.seqPartner,
        seqPartnerBranch: d.seqPartnerBranch,
        seqPartnerCoach: d.seqPartnerCoach,
      },
      "POST"
    ).then(() => {
      handleFetchPartnerList();
      dispatch({ type: "UPDATE_HOME_PARTNER_LIST_REFRESH" });
    });
  };

  const handleClickDeletePartner = (e: React.MouseEvent<HTMLImageElement>) => {
    e.stopPropagation();
    const centerName = d.partnerBranchName
      ? d.partnerName + " " + d.partnerBranchName
      : d.partnerName;
    dispatch({
      type: "ALERT_SETTING",
      data: {
        header: "연동센터 삭제",
        cancleYn: "D",
        redYn: true,
        body: centerName + `${endWithConsonant(centerName)} \n 삭제하시겠습니까?`,
        cancelAlert: () => {
          return;
        },
        closeAlert: handleDeletePartner,
        alert: true,
      },
    });
  };

  return (
    <div
      className={`center-mgnt${d.mainPartnerFlag === 1 ? " main" : ""}`}
      onClick={d.mainPartnerFlag === 1 ? undefined : handleClickUpdateMainPartner}
    >
      <div className="info-wrap">
        <div className="profile">
          <img
            className="profile-line"
            src={d.partnerImageFile || d.partnerBranchImageFile || icon_center_default}
          />
        </div>
        <div className="info">
          <div className={`medium${d.mainPartnerFlag === 1 ? " blue" : ""}`}>
            {d.partnerName}
            <br />
            {d.partnerBranchName}
          </div>
        </div>
      </div>
      <img className="icon" src={d.mainPartnerFlag === 1 ? main : main_gray} alt="" />
      <img
        className="remove-icon"
        src={icon_center_remove}
        alt=""
        onClick={handleClickDeletePartner}
      />
    </div>
  );
};

export default CenterMngtPopWrap;
